import _ from 'lodash'
import axios from 'axios'
import pAll from 'p-all'
import TranslateService from './TranslateService'

class EventService {
  async getEvents (query, options) {
    return await this.getData('events', query, options)
  }

  async getEventCategories (query) {
    return await this.getData('eventCategories', query)
  }

  async getLocations (query) {
    return await this.getData('locations', query)
  }

  async getDepartments (query) {
    return await this.getData('departments', query)
  }

  async getSpeakers (query) {
    return await this.getData('speakers', query)
  }

  async getOrganisers (query) {
    return await this.getData('organisers', query)
  }

  async getCampuses (query) {
    return await this.getData('campuses', query)
  }

  async getData (resource, query, options) {
    let params = {}
    if (!_.isEmpty(options)) {
      params = { ...options }
    }
    if (!_.isEmpty(query)) {
      // query = JSON.stringify(query)
      _.set(params, 'query', query)
    }
    const { data } = await axios.post(`/api/${resource}.php`, params)
    this.localizeData(data)
    return data
  }

  localizeData (data) {
    data = _.map(data, item => {
      const keys = _.keys(item)
      const regex = new RegExp(`_(${TranslateService.locales.join('|')})$`)
      const localeKeys = _.uniq(_.compact(_.map(keys, key => key.match(regex) && key.replace(regex, ''))))
      const unlocalizedKeys = _.filter(keys, key => !key.match(regex))
      _.each(localeKeys, localeKey => {
        _.each(TranslateService.locales, locale => {
          const newKey = `${_.camelCase(localeKey)}.${locale}`
          const oldKey = `${localeKey}_${locale}`
          const value = _.get(item, oldKey)
          if (_.isNumber(value) || !_.isEmpty(value)) {
            _.set(item, newKey, value)
            if (newKey !== oldKey) {
              _.unset(item, oldKey)
            }
          } else {
            _.unset(item, oldKey)
          }
        })
      })
      _.each(unlocalizedKeys, key => {
        let newKey = _.camelCase(key)
        const oldKey = key
        const value = _.get(item, oldKey)

        // if localizedObject Already exists, fallback to eng
        if (_.isPlainObject(_.get(item, newKey))) {
          newKey = `${newKey}.en`
        }

        if (_.isNumber(value) || !_.isEmpty(value)) {
          _.set(item, newKey, value)
          if (newKey !== oldKey) {
            _.unset(item, oldKey)
          }
        } else {
          _.unset(item, oldKey)
        }
      })
      // console.log(333, item)
      // console.log(localeKeys)
    })
  }
}

export default new EventService()
